import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
// Make sure to install react-icons: npm install react-icons
import { HiOutlineSearch, HiOutlineUser } from "react-icons/hi"; 
import "./Navbar.css"; // Ensure this matches the CSS provided in the previous step

const Navbar = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  // 1. Logic moved here from Hero.js
  const handleSearch = (e) => {
    if (e) e.preventDefault(); // Prevent form refresh
    if (query.trim()) {
      onSearch(query); // Pass data up to App.js
    }
  };

  return (
    <nav className="navbar">
      {/* Left: Logo & Links */}
      <div className="nav-left">
        <Link to="/" className="logo">QUICKFIT</Link>
        <div className="nav-links">
          <NavLink to="/brands">BRANDS</NavLink>
          <NavLink to="/blog">BLOG</NavLink>
          <NavLink to="/about">ABOUT</NavLink>
          <NavLink to="/support">SUPPORT</NavLink>
        </div>
      </div>

      {/* Right: Search & Profile */}
      <div className="nav-right">
        {/* Wrap input in a form so "Enter" key submits automatically */}
        <form className="search-container" onSubmit={handleSearch}>
          <HiOutlineSearch className="search-icon" />
          <input 
            type="text" 
            placeholder="Search" 
            className="search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </form>
        
        <Link to="/signup" className="profile-btn">
          <HiOutlineUser />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;